import { z } from "zod";

const numCsv = z.preprocess((v) => {
  if (Array.isArray(v)) return v.map(Number).filter((n) => Number.isFinite(n));
  if (typeof v === "string" && v.length) return v.split(",").map(Number).filter((n) => Number.isFinite(n));
  return undefined;
}, z.array(z.number().int()).optional());

const numOpt = z.preprocess((v) => {
  if (v === "" || v == null) return undefined;
  const n = Number(v);
  return Number.isFinite(n) ? n : undefined;
}, z.number().min(0).optional());

const strCsv = z.preprocess((v) => {
  if (Array.isArray(v)) return v.map(String).filter(Boolean);
  if (typeof v === "string" && v.length) return v.split("~").map((s) => s.trim()).filter(Boolean);
  return undefined;
}, z.array(z.string().max(80)).max(50).optional());

const boolOpt = z.preprocess((v) => {
  if (v === true || v === "true" || v === "1") return true;
  return undefined;
}, z.boolean().optional());

export const listingSearchSchema = z.object({
  page: z.preprocess((v) => v ? Number(v) : 1, z.number().int().min(1).default(1)),
  sort: z.enum(["new", "old", "price_asc", "price_desc", "alpha_asc", "alpha_desc", "best"]).default("best"),
  priceMin: numOpt,
  priceMax: numOpt,
  brands: numCsv,
  subs: numCsv,
  onlyOffers: boolOpt,
  avail: strCsv,
  health: z.enum(["great", "good", "ok"]).optional().catch(undefined),
  ing: z.enum(["great", "good"]).optional().catch(undefined),
  ingTags: strCsv,
});

export type ListingSearchParams = z.infer<typeof listingSearchSchema>;